<template>
  <router-link
    class="btn block w-full col-span-2 md:w-auto py-4 px-1 sm:px-4 bg-black text-white md:h-32"
    :class="{ active: active }"
    :to="url"
  >
    <div class="relative">
      <div class="text-center sm:text-left leading-tight">
        <span class="text-sm sm:text-base">
          {{ page.name }}
        </span>
        <span class="hidden md:block text-4xl">
          <span>{{ printNumber(kpi.value) }}</span>
        </span>
        <span class="hidden md:block">
          <span v-html="page.sub"></span>
        </span>
      </div>
      <div class="hidden sm:block w-1/2 absolute top-0 right-0">
        <spark-line class="w-1/2" :series="sparkLine" :id="`sparkline-${dimension}`" />
      </div>
    </div>
  </router-link>
</template>

<script>
import SparkLine from '@/components/SparkLine'
import { dimensionToSlug } from '@/utils/helpers'
import { iso3ToSlug } from '@/utils/countryMap'

export default {
  props: {
    dimension: {
      type: String
    }
  },
  components: {
    SparkLine
  },
  computed: {
    active() {
      return this.dimension === this.currentDimension
    },
    sparkLine() {
      const totals = this.$store.getters.seriesTotal(this.dimension, this.country)
      return totals[0].values
    },
    currentDimension() {
      return this.$store.state.dimension
    },
    country() {
      return this.$store.state.country
    },
    dimensionSlug() {
      return dimensionToSlug(this.dimension, this.$store.state.language)
    },
    locale() {
      return this.$store.getters.locale
    },
    regionSlug() {
      return this.$store.state.regionSlug
    },
    url() {
      return `/${this.regionSlug}/${this.dimensionSlug}${this.country ? `/${iso3ToSlug(this.country)}` : ''}`
    },
    kpi() {
      return this.$store.getters.kpi(this.dimension)
    },
    page() {
      return this.$store.getters.pageData(this.dimension)
    }
  },
  methods: {
    printNumber(num) {
      return num.toLocaleString(this.locale)
    }
  }
}
</script>

<style>
.btn.active,
.btn.router-link-active {
  color: theme('colors.black');
  background-color: theme('colors.brand.bright');
}
</style>
